<template>
  <div class="adminAccount">
  <account-all @tabUsrChange-event="tabUsrChangeEvent"></account-all>
  <component class="article" :is="shownComponent" @changeUsrMode="val => (shownComponent = val)" v-if="shownComponent"></component>
</div>
</template>
<script>
import accountAll from './sidebarmodeTab'
import account from "./accountSidebar"
import authority from "./authority"
export default {
  components: {
    account,
    accountAll,
    authority,
  },
  data () {
    return {
      shownComponent: 'account',
    }
  },
  computed: {
  },
  watch: {
  },
  created () {

  },
  methods: {
    tabUsrChangeEvent(payload){
      if(payload==1){
        this.shownComponent = 'account'
        // this.$emit('changeUsrMode','account')
      }else{
        this.shownComponent = 'authority'
        // this.$emit('changeUsrMode','authority')
      }
    }
  }
}
</script>
<style lang="less" scoped>
.adminAccount{
  flex: 1;
  display: flex;
  align-items: stretch;
  background: rgba(45, 63, 75, 1);
.adminHome {
  width: calc(100% - 304px);
  margin: 20px;
  flex: 1;
  display: flex;
  align-items: stretch;
  background: rgba(45, 63, 75, 1);

  .article {
    display: flex;
    flex: 1;
    overflow: hidden;
  }

  &.tableloding {

    // 加载数据时遮罩
    /deep/.el-loading-mask {
      background-color: rgb(34, 45, 53, .5);
    }

    // .el-loading-spinner i {
    //   color: @primaryTextColor;
    // }
    /deep/.el-loading-spinner .path {
      stroke: @primaryTextColor;
    }
  }
}

// #操作结果提示#
.showresultbox {
  display: flex;
  flex-direction: column;
  align-items: center;

  // 图标
  .showsuccess {
    border: 3px solid rgba(37, 255, 174, 1);
    background-color: rgba(19, 195, 156, 1);
    background-image: url(../../../assets/img/general/Icon_Finished.png);
    background-size: 70px 70px;
  }

  .showfail {
    border: 3px solid rgba(246, 189, 189, 1);
    background: rgba(251, 75, 75, 1);
    background-image: url(../../../assets/img/general/Icon_Failed.png);
    background-size: 120px 120px;
  }

  .showbase {
    width: 100px;
    height: 100px;
    box-sizing: border-box;
    background-repeat: no-repeat;
    background-position: center;
    border-radius: 50%;
  }

  // 提示
  .showresulttext {
    font-weight: bold;
    font-size: 18px;
    margin-top: 20px;
    margin-bottom: 30px;
    color: rgba(255, 255, 255, 1);
  }

  // 操作
  .showoperate {
    text-align: center;
  }

  .showresultbtn {
    width: 102px;
    height: 30px;
    margin-top: 10px;
    border-radius: 6px;
    background: @primaryTextColor;
    color: rgba(34, 45, 53, 1);
    font-size: 14px;
  }
}
}
</style>
